var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"demoBox",staticClass:"demo-box demo-box-hook",style:({
          width: _vm.thisWidth ? _vm.thisWidth + "px" : "",
          height: _vm.thisWidth ? _vm.thisWidth + "px" : ""}),attrs:{"data-clipboard-text":_vm.thisName}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"demo-no"},[_vm._v("\n    "+_vm._s(_vm.thisName)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116fa01f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/local/DemoBox.vue
// module id = null
// module chunks = 